<template>
  <div class="base-table">
    <table>
      <thead>
        <tr>
          <th
            v-for="(value, key, index) in pallet.table"
            :key="index"
          >
            {{ key }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            v-for="(value, key, index) in pallet.table"
            :key="index"
            :data-label="key"
          >
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="base-table__description">
      {{ pallet.description }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseTable',
  props: {
    pallet: {
      type: [Array, Object],
      default: null,
    },
  },
};
</script>
